module.exports = __webpack_public_path__ + "static/media/bg-mask-gray.5e8ebe5c.png";